export type ApplicationParameters = {
  loaded: boolean
  map: Map<string, string>
}

export type ApplicationInfoState = {
  name: string
  parameters: ApplicationParameters
  offset: number
  loadedOffset: boolean
}

const applicationInfoInitialState: ApplicationInfoState = {
  name: 'VTV Portal Client',
  parameters: { loaded: false, map: new Map() },
  offset: 0,
  loadedOffset: false
}

export const LOAD_DEVICE_CUSTOM_FIELDS = 'LOAD_DEVICE_CUSTOM_FIELDS'
export const LOAD_OFFSET_VALUE = 'LOAD_OFFSET_VALUE'
export const INITIALIZE_CUSTOM_FIELDS = 'INITIALIZE_CUSTOM_FIELDS'

export default function applicationReducer(
  state: ApplicationInfoState = applicationInfoInitialState,
  action: any
): ApplicationInfoState {
  switch (action.type) {
    case LOAD_DEVICE_CUSTOM_FIELDS:
      return { ...state, parameters: { loaded: true, map: action.payload || [] } }

    case LOAD_OFFSET_VALUE:
      return { ...state, offset: action.payload.data || 0, loadedOffset: action.payload.loaded }

    default:
      return { ...state }
  }
}